import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleAlert } from 'Images';

export const Title = () => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  return (
    <Stack gap='16px' m='24px 0'>
      <Typography variant='h2'>{dictionary.title}</Typography>
      <Typography variant='body3'>{dictionary.subTitle}</Typography>
      {!isDesktop && (
        <Stack
          direction='row'
          gap='8px'
          sx={{
            p: '12px',
            bgcolor: '#E7EDFF',
            border: '1px solid #E7EDFF',
            borderRadius: '12px',
          }}
        >
          <Avatar
            alt=''
            src={PurpleAlert}
            sx={{ width: '20px', height: '20px', mt: '2px' }}
          />
          <Typography variant='body6'>{dictionary.subTitleNoteDesc}</Typography>
        </Stack>
      )}
    </Stack>
  );
};
